import { AlertTriangle, Package } from "lucide-react";
import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/content";
import { Loading, useAdmin } from "./ui";

const Level = ({ p, threshold }) => {
  if (!p.tracked) return <span className="st-level is-none">Not tracked</span>;
  if (p.stock <= 0) return <span className="st-level is-low">Sold out</span>;
  return <span className={`st-level ${p.stock < threshold ? "is-low" : "is-ok"}`}>{p.stock}</span>;
};

export const StockTable = () => {
  const { data } = useAdmin("stock", "/admin/analytics/stock");
  if (!data) return <Loading />;
  const { products, threshold, low_count: low } = data;
  return (
    <div className="ad-card st-card" data-testid="stock-table">
      <div className="st-head">
        <h3><Package size={16} /> Product stock</h3>
        {low > 0
          ? <span className="st-alert" data-testid="stock-low-count"><AlertTriangle size={14} /> {low} need restocking (below {threshold})</span>
          : <span className="st-good" data-testid="stock-low-count">All tracked products are stocked</span>}
      </div>
      {products.length === 0 ? <p className="muted-sm">No products yet.</p> : (
        <div className="st-scroll">
          <table className="st-table">
            <thead><tr><th>Product</th><th>Size</th><th className="st-num">In stock</th></tr></thead>
            <tbody>
              {products.map((p) => (
                <tr key={p.id} className={p.low ? "is-low" : ""} data-testid={`stock-row-${p.id}`}>
                  <td><span className="st-name">{p.image && <img src={imgUrl(p.image, 80)} alt="" />}<span><strong>{p.name}</strong>{p.brand && <small>{p.brand}</small>}</span></span></td>
                  <td>{p.size || "—"}</td>
                  <td className="st-num" data-testid={`stock-level-${p.id}`}><Level p={p} threshold={threshold} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p className="muted-sm st-foot">You get an email when a product drops below {threshold}. Update stock in <Link to="/admin/shop" data-testid="stock-edit-link">Shop items</Link>.</p>
    </div>
  );
};
